import { Navigate, useParams } from 'react-router-dom';

export default function CustomerDetailPage() {
  const { id } = useParams();
  return <Navigate to={`/customers?open=${id}`} replace />;
}
